import React from "react";
import { MENU_ITEMS } from "./constants";
import { MenuItem } from "./MenuItem";

export const Menu = () => (
  <nav className="h-full">
    <ul className="flex justify-center items-center gap-10 h-full">
      {MENU_ITEMS.map(({ id, ...rest }) => (
        <MenuItem key={id} {...rest} />
      ))}
    </ul>
  </nav>
);
